import { Routes } from "@angular/router";
import { InternalAuthGuardService } from "./guards/internal-auth-guard.service";
import { ActiveSubAuthGuardService } from "./guards/active-sub-auth-guard.service";
import { NativeIosPublicSurfaceGuardService } from "./guards/native-ios-public-surface-guard.service";

export const routes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("./marketing/marketing-home/marketing-home.page").then(
				(m) => m.MarketingHomePage
			),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "landing",
		loadComponent: () =>
			import("./landing/landing.page").then((m) => m.LandingPage),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "demo",
		loadComponent: () =>
			import("./marketing/marketing-demo/marketing-demo.page").then(
				(m) => m.MarketingDemoPage
			),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "events/:instanceUid/:eventUid/entries",
		loadComponent: () =>
			import("./marketing/event-entry-list/event-entry-list.page").then(
				(m) => m.EventEntryListPage
			),
	},
	{
		path: "events/:instanceUid/:eventUid",
		loadComponent: () => import("./lap-times/riding-event.page").then(m => m.RidingEventPage),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "events",
		loadComponent: () =>
			import("./marketing/marketing-events/marketing-events.page").then(
				(m) => m.MarketingEventsPage
			),
	},
	{
		path: "race-management",
		redirectTo: "solutions/arenacross-race-management",
		pathMatch: "full",
	},
	{
		path: "solutions/race-management",
		redirectTo: "solutions/arenacross-race-management",
		pathMatch: "full",
	},
	{
		path: "solutions/motocross-race-management",
		redirectTo: "solutions/arenacross-race-management",
		pathMatch: "full",
	},
	{
		path: "owner",
		loadComponent: () => import("./owner/owner.page").then((m) => m.OwnerPage),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "pricing",
		loadComponent: () =>
			import("./pricing/pricing.page").then((m) => m.PricingPage),
		data: { pricingMode: "landing" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "pricing/riders",
		loadComponent: () =>
			import("./pricing/pricing.page").then((m) => m.PricingPage),
		data: { pricingMode: "riders" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "pricing/owners",
		loadComponent: () =>
			import("./pricing/pricing.page").then((m) => m.PricingPage),
		data: { pricingMode: "owners" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "features",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "feature" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "features/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "feature" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "hardware",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "hardware" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "hardware/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "hardware" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "solutions",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "solution" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "solutions/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "solution" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "riders",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "rider" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "riders/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "rider" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "track-owners",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "track-owner" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "track-owners/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "track-owner" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "promoters",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "promoter" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "promoters/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "promoter" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "safety",
		loadComponent: () =>
			import("./marketing/marketing-overview/marketing-overview.page").then(
				(m) => m.MarketingOverviewPage
			),
		data: { collection: "safety" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "safety/:slug",
		loadComponent: () =>
			import("./marketing/marketing-page/marketing-page.component").then(
				(m) => m.MarketingPageComponent
			),
		data: { collection: "safety" },
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "merch",
		loadComponent: () => import("./merch/merch.page").then((m) => m.MerchPage),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "owner/pricing",
		redirectTo: "/pricing/owners",
		pathMatch: "full",
	},
	{
		path: "owner/roi",
		loadComponent: () =>
			import("./roi-calc/roi-calc.page").then((m) => m.RoiPage),
		canActivate: [NativeIosPublicSurfaceGuardService],
	},
	{
		path: "eula",
		loadComponent: () => import("./eula/eula.page").then((m) => m.EulaPage),
	},
	{
		path: "support",
		loadComponent: () =>
			import("./support/support.page").then((m) => m.SupportPage),
	},
	{
		path: "login",
		loadComponent: () =>
			import("./core/login/pages/login/login.page").then((m) => m.LoginPage),
	},
	/// behind login
	{
		path: "private-track-invite",
		loadComponent: () =>
			import("./private-track-invite/private-track-invite.page").then(
				(m) => m.PrivateTrackInvitePage
			),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "dashboard",
		loadComponent: () =>
			import("./dashboard/dashboard.page").then((m) => m.DashboardPage),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "account",
		loadComponent: () =>
			import("./account/account.page").then((m) => m.AccountPage),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "subscription-access",
		loadComponent: () =>
			import("./subscription-access/subscription-access.page").then(
				(m) => m.SubscriptionAccessPage
			),
		canActivate: [InternalAuthGuardService],
	},

	{
		path: "entries",
		loadComponent: () =>
			import("./entries/entries.page").then((m) => m.EntriesPage),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "race-results",
		loadComponent: () =>
			import("./race-results/race-results.page").then((m) => m.RaceResultsPage),
		canActivate: [InternalAuthGuardService],
	},
	{
		path: "live-stream",
		loadComponent: () =>
			import("./live-stream/live-stream.page").then((m) => m.LiveStreamPage),
		canActivate: [ActiveSubAuthGuardService],
	},
	{
		path: "lap-times",
		loadComponent: () =>
			import("./lap-times/lap-times.page").then((m) => m.LapTimesPage),
		canActivate: [ActiveSubAuthGuardService],
	},
	{
		path: "cart",
		loadComponent: () => import("./cart/cart.page").then((m) => m.CartPage),
		canActivate: [InternalAuthGuardService, NativeIosPublicSurfaceGuardService],
	},
	{
		path: "video-clips",
		loadComponent: () =>
			import("./video-clips/video-clips.page").then((m) => m.VideoClipsPage),
		canActivate: [ActiveSubAuthGuardService],
	},
	{
		path: "payment-settings",
		loadComponent: () =>
			import("./payment-settings/payment-settings.page").then(
				(m) => m.PaymentSettingsPage
			),
		canActivate: [InternalAuthGuardService, NativeIosPublicSurfaceGuardService],
	},
	{
		path: "order-status",
		loadComponent: () =>
			import("./order-status/order-status.page").then((m) => m.OrderStatusPage),
		canActivate: [InternalAuthGuardService],
	},
];
